<template>
    <div>
<!--        <VTcPlayer ref="tcPlayer"-->
<!--                   :options="options"-->
<!--                   elmId="1"-->
<!--                   @load="onLoad"-->
<!--                   @play="onPlay"-->
<!--                   @pause="onPause" />-->

        <video ref="flvplayerVideoRef"
               :poster="require('@/assets/img/bigScreen/defaultVideoBg.png')"
               :controls="true"
               autoplay
               muted
               width="100%">
        </video>
    </div>
</template>


<script>
    import {VTcPlayer} from 'v-tcplayer';
    import flvjs from "flv.js";

    export default {
        data() {
            return {
                isshow:true, //加载完成数据后，再绑定为true
                options: {},
                flvPlayer:null,
            }
        },

        components:{
            VTcPlayer
        },

        computed:{
            player() {
                // tcPlayer实例
                return this.$refs.tcPlayer.vTcPlayer

            },

        },
        created() {
            this.createPlayer();
            this.createFlvPlayer()
        },
        monuted(){

            // this.createPlayer();

        },

        methods: {

            createFlvPlayer(){
                this.flvPlayer = flvjs.createPlayer({
                    type: "flv",
                    isLive: false,
                    url: 'http://192.168.1.252:1938/live/8021e8d4def8daedd021e40a3e3c71ac.flv'

                });
                this.player.attachMediaElement(this.$refs.flvplayerVideoRef);
            },

            createPlayer(){

                this.options = {
                    "m3u8": "http://ivi.bupt.edu.cn/hls/cctv1hd.m3u8", //请替换成实际可用的播放地址
                    "autoplay" : true,      //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    "poster" : "http://www.test.com/myimage.jpg",
                    "width" :  '480',//视频的显示宽度，请尽量使用视频分辨率宽度
                    "height" : '320'//视频的显示高度，请尽量使用视频分辨率高度
                }


            },

            // 视频加载
            onLoad() {

            },
            // 视频点击播放
            onPlay() {
                this.player.play()
            },
            // 视频点击暂停
            onPause() {

            },


            play(){
                this.player.play()

            },

            getCurrentTime(){
                this.player.currentTime()

            },

            loadNewVideo(url){
                this.player.load(url)
            },
        }
    }
</script>

<style scoped>
    #palyback {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-top: 2rem;
        background-color: #1c302e;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 59.375rem;
        position: relative;
    }
    .else {
        width: 400px;
        position: absolute;
        top: 3%;
        right: 2%;
        z-index: 100;
    }

    .box-title {
        width: 50px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: pink;
        position: absolute;
        bottom: 3%;
        right: 2%;
    }
</style>